import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { usePostHog } from "posthog-js/react";

const LogoutPage = () => {
  const { logout } = useAuth0();
  const posthog = usePostHog()

  useEffect(() => {
    // Beacon so the event survives the redirect; reset after, so it's still attributed to the user.
    posthog?.capture('clicked_log_out', {}, { send_instantly: true, transport: 'sendBeacon' })
    posthog?.reset()
    logout({ logoutParams: { returnTo: window.location.origin } })
  }, [posthog, logout])

  return (<div></div>)
};

export default LogoutPage;
